(() => {
  if (window.WolfCollectionCardResults) return;

  const cache = new Map();
  let cloneSequence = 0;

  function sectionUrl(collectionUrl, sectionId) {
    const url = new URL(collectionUrl, window.location.origin);
    if (url.origin !== window.location.origin) throw new Error('Collection cards must be on this storefront.');
    if (!sectionId) throw new Error('Collection cards require a section.');
    ['wc_color', 'wc_form', 'wc_page'].forEach((key) => url.searchParams.delete(key));
    url.searchParams.set('section_id', sectionId);
    url.searchParams.set('page', '1');
    url.hash = '';
    url.searchParams.sort();
    return url;
  }

  async function fetchCards(firstUrl, sectionId) {
    let url = firstUrl;
    const cards = new Map();
    const seen = new Set();
    while (url) {
      url.searchParams.sort();
      if (seen.has(url.href)) throw new Error('Collection cards returned a repeated page.');
      seen.add(url.href);
      const response = await fetch(url.href, { signal: AbortSignal.timeout(20000) });
      if (!response.ok) throw new Error(`Collection cards unavailable (${response.status}).`);
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      html.querySelectorAll('li[data-wolf-filter-product]').forEach((card) => {
        cards.set(String(card.dataset.wolfFilterProduct), card);
      });
      const nextHref = html.querySelector('[data-wolf-filter-next]')?.getAttribute('href');
      if (!nextHref) break;
      const next = new URL(nextHref, url);
      if (next.origin !== window.location.origin) throw new Error('Invalid collection cards page.');
      // Shopify pagination links can omit the Section Rendering API parameters.
      for (const [key, value] of url.searchParams) {
        if (key !== 'page' && !next.searchParams.has(key)) next.searchParams.append(key, value);
      }
      next.searchParams.set('section_id', sectionId);
      next.hash = '';
      url = next;
    }
    return cards;
  }

  function load(collectionUrl, sectionId) {
    let url;
    try {
      url = sectionUrl(collectionUrl, sectionId);
    } catch (error) {
      return Promise.reject(error);
    }
    const key = url.href;
    if (!cache.has(key)) {
      cache.set(key, fetchCards(url, sectionId).catch((error) => {
        cache.delete(key);
        throw error;
      }));
    }
    return cache.get(key);
  }

  function renderCard(cards, match, suffix) {
    const original = cards.get(String(match.product.id));
    if (!original) throw new Error(`Collection card missing for product ${match.product.id}.`);
    const card = original.cloneNode(true);
    const nodes = [card, ...card.querySelectorAll('*')];
    const ids = new Map();
    const uniqueSuffix = String(suffix || `result-${++cloneSequence}`).replace(/[^a-zA-Z0-9_-]/g, '-');
    nodes.forEach((node) => {
      const id = node.getAttribute('id');
      if (id) {
        const replacement = `${id}--${uniqueSuffix}`;
        ids.set(id, replacement);
        node.setAttribute('id', replacement);
      }
      node.classList.remove('scroll-trigger', 'animate--slide-in');
    });
    nodes.forEach((node) => {
      ['for', 'form', 'aria-labelledby', 'aria-describedby', 'aria-controls'].forEach((attribute) => {
        const value = node.getAttribute(attribute);
        if (!value) return;
        node.setAttribute(attribute, value.split(/\s+/).map((id) => ids.get(id) || id).join(' '));
      });
    });
    return card;
  }

  function selectColor(card, match, normalizeColor) {
    const swatches = [...card.querySelectorAll('[data-wolf-variant-id]')];
    const variant = match.variant;
    const exact = swatches.find((swatch) => String(swatch.dataset.wolfVariantId) === String(variant.id));
    const color = normalizeColor(variant.color);
    const swatch = exact || (color && swatches.find((choice) => normalizeColor(choice.dataset.wolfVariantColor) === color));
    if (!swatch) return false;
    // Connected set-builder cards own the image, buying variant and stock updates.
    swatch.click();
    return true;
  }

  window.WolfCollectionCardResults = { load, renderCard, selectColor };
})();
